export default "__VITE_ASSET__fcea84ef__"